import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import './css/Slideshow.css';

function Slides(props) {
    return (
      <div className="slide-container">
        <Fade>
          {props.images.map((image) => {
            return (
                <div className="each-slide">
                  <div style={{'backgroundImage': `url(${image})`}}>
                  </div>
                </div>
            );
          })}
        </Fade>
      </div>
    );
}

export default Slides;
